// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3SIB5","actions":"GroupTable_actions__2OqlE","deleteModalFooter":"GroupTable_deleteModalFooter__1cn87"};